import React, { JSX } from "react";
import { ProductStatusType, UploadStatus } from "app/types";
import { EntityType } from "../CatalogTable";
import { ImportTaskType } from "importTask/types";
import { SorterResult } from "antd/es/table/interface";

// components
import Column from "antd/es/table/Column";
import { Tag, Tooltip } from "antd";

type TagColorType = "processing" | "success" | "warning" | "default" | "error";

const tagColors: Record<ProductStatusType | UploadStatus, TagColorType> = {
  "Новый": "processing",
  "Успешно": "success",
  "В загрузке": "warning",
  "Остановлено": "default",
  "Ошибка": "error",
  "Размещен": "success",
  "На модерации": "warning",
  "Отклонен": "error",
  "Черновик": "default",
};

const getTagColor = (tag: ProductStatusType | UploadStatus): TagColorType => tagColors[tag];

const myCatalogStatuses: {[key: string]: string} = {
  published: "Размещен",
  moderation: "На модерации",
  rejected: "Отклонен",
  needs_update: "Отмена",
  canceled_by_client: "Требует обновления",
  error: "Ошибка",
  draft: "Черновик",
};

export const renderStatusColumn = (
  renderColumnTitle: (title: string) => JSX.Element,
  sorter: SorterResult<any>,
  onClickHandler?: (...args: any[]) => void,
): JSX.Element => {
  return (
    <Column
      key="Status"
      title={renderColumnTitle("Статус")}
      dataIndex="status"
      width={150}
      sorter={{ multiple: 3 }}
      sortOrder={sorter?.field === "status" ? sorter?.order : undefined}
      showSorterTooltip={false}
      sortDirections={["ascend", "descend"]}
      render={(value: ProductStatusType, entity: EntityType) => {
        const { id, status, source, is_periodic } = entity as ImportTaskType || {};

        const isNavigateToEdit: boolean = "is_periodic" in entity && !is_periodic && status === "Черновик";

        return (
          <Tooltip title={(entity as ImportTaskType)?.status ?? null}>
            <Tag
              color={getTagColor(value)}
              className={`w-fit ${isNavigateToEdit && !!onClickHandler ? "cursor-pointer" : ""}`}
              onClick={() => isNavigateToEdit && onClickHandler?.(id, source)}
            >
              {myCatalogStatuses[value] || value}
            </Tag>
          </Tooltip>
        );
      }}
    />
  );
};
